<template>
  <v-chart :options="chartOptions" :autoresize="true" class="daily-trend-chart" :style="{ height: height + 'px' }" />
</template>

<script>
// Ported from dashboard-web/src/components/DailyTrendChart.tsx (a Recharts AreaChart) to an
// ECharts line/area chart, since walton-web-cms is a plain Vue 2 app (no Recharts/React here).
import ECharts from "vue-echarts/dist/vue-echarts.js";
import "echarts/lib/chart/line";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/grid";

export default {
  name: "DailyTrendChart",
  components: {
    "v-chart": ECharts
  },
  props: {
    data: {
      type: Array,
      default: () => []
    },
    dateKey: {
      type: String,
      default: "date"
    },
    valueKey: {
      type: String,
      required: true
    },
    name: {
      type: String,
      default: ""
    },
    color: {
      type: String,
      default: "#5b8ff9"
    },
    valueFormatter: {
      type: Function,
      default: v => String(v)
    },
    dateFormatter: {
      type: Function,
      default: v => v
    },
    height: {
      type: Number,
      default: 240
    }
  },
  computed: {
    chartOptions() {
      const dates = this.data.map(d => d[this.dateKey]);
      const values = this.data.map(d => d[this.valueKey]);
      const valueFormatter = this.valueFormatter;
      const dateFormatter = this.dateFormatter;
      const seriesName = this.name;
      return {
        color: [this.color],
        grid: { left: 52, right: 20, top: 20, bottom: 30, containLabel: false },
        tooltip: {
          trigger: "axis",
          formatter(params) {
            const p = params[0];
            if (!p) return "";
            return (
              dateFormatter(p.axisValue) +
              "<br/>" +
              p.marker +
              seriesName +
              ": " +
              valueFormatter(Number(p.value))
            );
          }
        },
        xAxis: {
          type: "category",
          data: dates,
          boundaryGap: false,
          axisLabel: {
            formatter(v) {
              return dateFormatter(v);
            },
            color: "#9aa5b1",
            fontSize: 12
          },
          axisLine: { lineStyle: { color: "#dcdfe6" } },
          axisTick: { show: false }
        },
        yAxis: {
          type: "value",
          axisLabel: {
            formatter(v) {
              return valueFormatter(Number(v));
            },
            color: "#9aa5b1",
            fontSize: 12
          },
          axisLine: { show: false },
          splitLine: { lineStyle: { color: "#ebeef5" } }
        },
        series: [
          {
            name: seriesName,
            type: "line",
            data: values,
            smooth: true,
            symbol: "circle",
            showSymbol: false,
            areaStyle: { opacity: 0.15 },
            lineStyle: { width: 2 }
          }
        ]
      };
    }
  }
};
</script>

<style scoped>
.daily-trend-chart {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/auditLog/DailyTrendChart.vue